
import React from 'react';

export const PlusIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    add
  </span>
);